import { createBrowserHistory } from 'history'
import qhistory from 'qhistory'
import qs from 'qs'

const browserHistory = qhistory(createBrowserHistory(), qs.stringify, qs.parse)

export { browserHistory }
